import { Injectable, inject, ViewChild } from '@angular/core';
import { Database, equalTo, listVal, objectVal, onValue, orderByChild, push, query, ref, remove, update } from '@angular/fire/database';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Storage, ref as refStorage, getDownloadURL, listAll, uploadBytes, deleteObject, uploadBytesResumable  } from '@angular/fire/storage';

@Injectable({
  providedIn: 'root'
})
export class TreemapService {
  private database: Database = inject(Database);
  private storage = inject(Storage);
  private http = inject(HttpClient);

  obtenerTreeMap (idEntrada:string) {
    return this.http.post(environment.entradas.treeMap, { 'idEntrada': idEntrada });
  }

  eliminarEntrada (idEntrada: string) {
    return this.http.post(environment.entradas.eliminar, { 'idEntrada': idEntrada });
  }
}